import gql from "graphql-tag";

export const UPDATE_PROJECT = gql`
  mutation ($input: updateProjectInput) {
    updateProject(input: $input) {
      _id
    }
  }
`;
